<ejs-multiselect  #multiselect
                  [allowFiltering]="true"
                  [dataSource]="data"
                  [(value)]="outputValue"
                  width="200px"
                  [ngClass]="{'h-auto': outputValue !== null}"
                  [fields]="fieldsSettings">
</ejs-multiselect>
